
const VC_S3_BASE = "https://markoknow.s3.ap-south-1.amazonaws.com/static/org";

export const VC_ASSETS = {
  hero: `${VC_S3_BASE}/hero.png`,
  access: `${VC_S3_BASE}/access.png`,
  skill: `${VC_S3_BASE}/skill.png`,
  handson: `${VC_S3_BASE}/handson.png`,
  exploreBg: `${VC_S3_BASE}/hero-extension-image.png`,
};
